<template>
  <vx-modal :title="$t(title)" :width="width">
    <template v-slot:body>
      <div v-if="!isDelete" class="px-2">
        
        <vs-table :data="listForms">
          <template slot="thead">
            <vs-th>{{ $t("MODALS.listForms.name") }}</vs-th>
            <vs-th>{{ $t("MODALS.listForms.state") }}</vs-th>
            <vs-th>{{ $t("MODALS.listForms.date") }}</vs-th>
            <vs-th></vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :state="rowDisabled(tr)" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name === "" ? data[indextr].key : data[indextr].name }}
              </vs-td>

              <vs-td :data="data[indextr].method">
                {{ $t(`MODALS.listForms.${data[indextr].method}`) }}
              </vs-td>

              <vs-td :data="data[indextr].date_create">
                {{ data[indextr].date_create | formatDate }}
              </vs-td>
              <vs-td :data="data[indextr].date_create">
                <vs-button
                  :disabled="tr.key === idForm"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-check"
                  @click="selectedForm(tr.key)"
                ></vs-button>
              </vs-td>
              <vs-td :data="data[indextr].date_create">
                <vs-button
                  :disabled="tr.key === idForm"
                  color="danger"
                  type="border"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="deleteForm(tr.key)"
                ></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <div v-if="isDelete" class="px-4 py-4">
        <div class="vs-dialog-text">
          <span class="block text-center mb-4">{{ $t("MODALS.listForms.messaggeAlert") }}</span>
          <span class="block text-center">{{ $t("MODALS.listForms.confirmMessage") }}</span>
        </div>

        <div class="flex justify-end mt-5">
          <vs-button class="mr-4" color="success" type="filled" @click="accept">{{
            $t("MODALS.listForms.btnAccept")
          }}</vs-button>
          <vs-button color="danger" type="filled" @click="isDelete = false">{{
            $t("MODALS.listForms.btnCancel")
          }}</vs-button>
        </div>
      </div>
    </template>
  </vx-modal>
</template>

<script type="text/javascript">
import { mapState, mapActions, mapMutations } from "vuex";
import {
  getListForm,
  clearIndexDbByIdForm,
  ativeOneForm,
  inactiveAllForms
} from "@/serviforms/designer/indexDB/logic.js";
import dataUtils from "@/helpers/DateUtils.js";

export default {
  data() {
    return {
      listForms: [],
      isDelete: false,
      keyForm: ""
    };
  },
  mounted() {
    this.getListForms();
  },
  filters: {
    formatDate(date) {
      return dataUtils.toDefaultDateTime(date, "DD MMM YYYY");
    }
  },
  methods: {
    ...mapMutations("resource", ["UPDATE_STATE", "ADD_QUESTION", "CLEAR_DATA"]),
    ...mapActions("resource", ["recreateForm", "getCreatedDependencies"]),
    async getListForms() {
      const { companyID, uuid } = this.$store.state.user;
      const result = await getListForm({ companyID, uuid });
      this.listForms = result;
    },
    rowDisabled(tr) {
      if (tr.key === this.idForm) return "success";
    },
    deleteForm(key) {
      this.isDelete = true;
      this.keyForm = key;
    },
    async accept() {
      await clearIndexDbByIdForm(this.keyForm);
      this.getListForms();
      this.isDelete = false;
    },
    async selectedForm(key) {
      await inactiveAllForms();
      await ativeOneForm(key);
      await this.recreateForm(key);
      this.getCreatedDependencies();
      this.UPDATE_STATE({ key: "activePopup", value: false });  
    }
  },
  computed: {
    ...mapState("resource", ["activePopup", "idForm"]),
    width() {
      if (this.isDelete) return "30%";
      return "50%";
    },
    title() {
      if (this.isDelete) return "MODALS.listForms.titleClean";
      return "MODALS.listForms.titleSelect";
    }
  }
};
</script>
